/* Fashion CITY — 커스텀 스웻셔츠 색상 사진 + 자수/인쇄 위치
   ★ 색을 넣거나 빼려면 아래 목록만 고치면 됩니다.
       c('보이는 이름', '파일이름조각')  →  fc-crew-<조각>.jpg (앞면) / fc-crew-back-<조각>.jpg (뒷면)
       뒷면 사진이 아직 없으면 세 번째 칸에 false 를 넣으세요.
   ★ 사진은 쇼피파이 관리자 → 콘텐츠 → 파일 에 올립니다.
   ※ 이 파일은 fc-po-colors.js 다음에 실행됩니다.
*/
window.FCPO_STYLES = window.FCPO_STYLES || {};
(function () {
  var BASE = 'https://cdn.shopify.com/s/files/1/0372/5544/6665/files/fc-crew-';
  function c(name, slug, hasBack) {
    var row = [name, BASE + slug + '.jpg'];
    if (hasBack !== false) row.push(BASE + 'back-' + slug + '.jpg');
    return row;
  }

  window.FCPO_STYLES['custom-sweatshirt-your-design'] = {
    styleLabel: 'Style',
    colorLabel: 'Sweatshirt color',
    propStyle: 'Style',
    propColor: 'Sweatshirt color',
    styles: [
      {
        n: 'Oversized Crewneck',
        sku: '',
        colors: [
          c('Black', 'Black'),
          c('Ash Grey', 'Ash-Grey'),
          c('White', 'White'),
          c('Sand', 'Sand'),
          c('Brown', 'Brown'),
          c('Navy', 'Navy'),
          c('Indigo', 'Indigo'),
          c('Royal', 'Royal'),
          c('Light Blue', 'Light-Blue'),
          c('Purple', 'Purple'),
          c('Burgundy', 'Burgundy'),
          c('Red', 'Red'),
          c('Orange', 'Orange'),
          c('Hot Pink', 'Hot-Pink'),
          c('Light Pink', 'Light-Pink'),
          c('Forest Green', 'Forest-Green'),
          c('Kelly Green', 'Kelly-Green'),
          c('Olive', 'Olive')
        ]
      }
    ]
  };
})();

/* 이 사진에 맞춘 자수/인쇄 자리
   x, y  : 사진 왼쪽 위가 0,0 / 오른쪽 아래가 100,100  (y 숫자가 클수록 아래)
   w     : Medium 일 때 폭 (사진 가로폭의 %)
   sizes : [Small, Medium, Large] 의 실제 인치
   view  : 'back' 이면 뒷면 사진으로 바뀝니다
   ※ 소매(Sleeve) 자리는 뺐습니다. 다시 쓰려면 아래 한 줄을 추가하세요.
     { v: 'Sleeve', x: 15, y: 56, w: 9, sizes: [1.5, 2, 3] }
*/
window.FCPO_PLACE_BY_HANDLE = window.FCPO_PLACE_BY_HANDLE || {};
window.FCPO_PLACE_BY_HANDLE['custom-sweatshirt-your-design'] = [
  { v: 'Left chest', x: 37, y: 31, w: 13, sizes: [3, 4, 5] },
  { v: 'Full front', x: 50, y: 37, w: 36, sizes: [11, 12, 13] },
  { v: 'Full back',  x: 50, y: 38, w: 36, sizes: [11, 12, 13], view: 'back' }
];